import React, { FC } from 'react'
import { Box, Stack, Text } from '@lojinha/design-system'
import { CheckCircleOutline } from '@lojinha/design-system/src/icons'
import { UserCreditUsage } from '@lojinha/palantir'
import {
  numberToCurrency,
  numberToCurrencyAriaLabel,
} from '@lojinha/helpers/src'
import { Row, TextEllipsis } from './styles'

interface MGMReferralListProps {
  referrals: UserCreditUsage[]
  maxHeight?: string
}

export const MGMReferralList: FC<MGMReferralListProps> = ({
  referrals = [],
  maxHeight = '295px',
}) => (
  <Box maxHeight={maxHeight} overflowY="auto">
    <Stack margin="x0">
      {referrals.map((referral, index) => (
        <Row key={index} index={index} py="x12">
          <TextEllipsis whiteSpace="nowrap">{referral.userName}</TextEllipsis>
          <Stack layout="horizontal">
            <Text
              whiteSpace="nowrap"
              color="blueberryLight"
              aria-label={numberToCurrencyAriaLabel(referral.amount || 0)}
              isBold
            >
              {numberToCurrency(referral.amount)}
            </Text>
            <CheckCircleOutline color="blueberryLight" />
          </Stack>
        </Row>
      ))}
    </Stack>
  </Box>
)
